// src/PlanningValide.jsx
import React, { useEffect, useState } from "react";
import { fetchListeGardesValidee, formatMedecinGarde } from "./gardesV2.js";

function PlanningValide({ mois = "2026-02", typeGarde = "PR2" }) {
  const [planning, setPlanning] = useState([]);
  const [loading, setLoading] = useState(true);
  const [estValidee, setEstValidee] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError(null);
    fetchListeGardesValidee({ mois, typeGarde })
      .then(({ estValidee: listeEstValidee, lignes }) => {
        if (cancelled) return;
        setEstValidee(listeEstValidee);
        setPlanning(lignes);
      })
      .catch((err) => {
        if (cancelled) return;
        setEstValidee(false);
        setPlanning([]);
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [mois, typeGarde]);

  if (loading) return <p>⏳ Chargement...</p>;

  if (error) {
    return (
      <p style={{ color: "red" }}>
        ⚠️ {error}
      </p>
    );
  }

  if (!estValidee || planning.length === 0) {
    return (
      <p style={{ color: "red" }}>
        ⚠️ Le planning {mois} n’a pas encore été validé par le responsable.
      </p>
    );
  }

  return (
    <div style={{ maxWidth: "1000px", margin: "20px auto" }}>
      <h2>Planning validé – {typeGarde} – {mois}</h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "6px",
                background: "#f3f4f6",
              }}
            >
              Date
            </th>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "6px",
                background: "#f3f4f6",
              }}
            >
              Médecin de garde
            </th>
          </tr>
        </thead>
        <tbody>
          {planning.map(({ date, medecin }) => (
            <tr key={date}>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                {date}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                {formatMedecinGarde(medecin)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlanningValide;
